import React from "react";
import { Mail } from "lucide-react";

const KINDS = [
    { k: "guest", l: "Misafir e-postaları (voucher)" },
    { k: "hotel", l: "Otel e-postaları (rezervasyon onayı)" },
    { k: "application", l: "Tesis başvuru e-postaları" },
    { k: "support", l: "Destek e-postaları" },
];
const INPUT = "w-full px-3 py-2 rounded-xl bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-sm font-medium text-slate-900 dark:text-white";

export function EmailSettingsSection({ value, onChange, Section, Field }) {
    const es = value || {};
    const set = (patch) => onChange({ ...es, ...patch });
    const setMap = (key, k, v) => set({ [key]: { ...(es[key] || {}), [k]: v } });
    return (
        <Section icon={<Mail className="h-4 w-4" />} title="E-posta Ayarları">
            <p className="text-xs text-slate-500 mb-3">Gönderen adres her zaman doğrulanmış <b>noreply@msonlinetravel.com</b> olur. Alıcı “Yanıtla” dediğinde cevap aşağıdaki yanıt adresine gider. Boş bırakılan türler varsayılanı kullanır.</p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-testid="email-settings">
                <Field label="Varsayılan Gönderen Adı"><input data-testid="email-from-name" value={es.from_name || ""} onChange={(e) => set({ from_name: e.target.value })} placeholder="msonlinetravel" className={INPUT} /></Field>
                <Field label="Varsayılan Yanıt Adresi (Reply-To)"><input data-testid="email-default-reply-to" type="email" value={es.default_reply_to || ""} onChange={(e) => set({ default_reply_to: e.target.value })} placeholder="rezervasyon@msonlinetravel.com" className={INPUT} /></Field>
            </div>
            <div className="mt-4 rounded-xl border border-slate-200 dark:border-slate-800 divide-y divide-slate-100 dark:divide-slate-800">
                {KINDS.map(({ k, l }) => (
                    <div key={k} className="grid grid-cols-1 md:grid-cols-3 gap-3 p-3 items-center">
                        <div className="text-sm font-semibold text-slate-700 dark:text-slate-200">{l}</div>
                        <input data-testid={`email-from-name-${k}`} value={(es.from_names || {})[k] || ""} onChange={(e) => setMap("from_names", k, e.target.value)} placeholder="Gönderen adı (opsiyonel)" className={INPUT} />
                        <input data-testid={`email-reply-to-${k}`} type="email" value={(es.reply_to || {})[k] || ""} onChange={(e) => setMap("reply_to", k, e.target.value)} placeholder="Yanıt adresi (opsiyonel)" className={INPUT} />
                    </div>
                ))}
            </div>
        </Section>
    );
}
